import { Box, Skeleton } from '@mui/material'

type TableSkeletonProps = {
  rowsCount: number
  columnsCount: number
}

export const TableSkeleton = ({ rowsCount, columnsCount }: TableSkeletonProps) => (
  <Box
    sx={{
      borderRadius: 0,
      height: 'calc(100vh - 280px)',
      backgroundColor: 'background.paper',
      overflow: 'hidden',
    }}
  >
    {/* Header skeleton */}
    <Box
      sx={{
        display: 'flex',
        backgroundColor: 'background.paper',
        borderBottom: '1px solid',
        borderColor: 'divider',
        justifyContent: 'space-between',
        py: '11px',
        px: 2,
      }}
    >
      {Array.from({ length: columnsCount }, (_, index) => ({
        key: `header-col-${index}`,
        position: index,
      })).map(item => (
        <Skeleton
          key={item.key}
          variant="text"
          width={item.position === 8 ? 200 : 120}
          height={24}
          sx={{ mr: 2, flexShrink: 0 }}
        />
      ))}
    </Box>

    {/* Body skeleton */}
    {Array.from({ length: rowsCount }, (_, rowIndex) => ({
      key: `skeleton-row-${rowIndex}`,
      position: rowIndex,
    })).map(rowItem => (
      <Box
        key={rowItem.key}
        sx={{
          display: 'flex',
          borderBottom: '1px solid',
          borderColor: 'divider',
          justifyContent: 'space-between',
          py: '24px',
          px: 2,
          '&:last-of-type': {
            borderBottom: 'none',
          },
        }}
      >
        {Array.from({ length: 9 }, (_, colIndex) => ({
          key: `skeleton-col-${colIndex}`,
          position: colIndex,
        })).map(colItem => (
          <Skeleton
            key={`${rowItem.key}-${colItem.key}`}
            variant="text"
            width={colItem.position === 8 ? 200 : 120}
            height={24}
            sx={{ mr: 2, flexShrink: 0 }}
          />
        ))}
      </Box>
    ))}
  </Box>
)
